(function () {
  const SECTION_SELECTOR = '.membership-earn-center';
  const failedTaskIconCodes = new Set();
  // Rays task icons keyed by bpTaskId. Use miles task SVGs only (no -B benefit icons).
  const RAYS_TASK_ICON_BY_BP_TASK_ID = {
    14: 'BIRTHDAY_GIFT',             // Birthday care
    99: 'GENERATE_ENERGY',           // Points increase
    101: 'FIRST_ORDER',              // Redeem coupon
    102: 'SHOP_ON_WEBSITE',          // Purchase on website
    106: 'REGISTER',                 // User registration
    108: 'COMPLETE_PROFILE',         // Complete profile
    120: 'BIND_DEVICE_FIRST',        // Points deducted for activity
    121: 'BIND_DEVICE_FIRST',        // Points rewarded for activity
    124: 'account-new-edit',         // Email change / points migration
    126: 'POST_USED_BY_OFFICIAL',    // Official use of post content
    127: 'BIND_DEVICE_FIRST',        // Renogy game deduction
    128: 'USE_SCENE',                // Select scene
    129: 'COMPLETE_QUESTIONNAIRE',   // Complete questionnaire
    130: 'BIRTHDAY',                 // Fill in birthday
    131: 'GENERATE_ENERGY',          // Select points deduction
    132: 'GENERATE_ENERGY',          // Select points refund
    136: 'SUBSCRIBE_EMAIL_FIRST',    // Subscribe to official email
    137: 'FIRST_ORDER',              // Redeem gift card
    138: 'BIND_DEVICE_FIRST',        // Lucky draw
    139: 'FIRST_POST',               // Renogy user star
    140: 'SUBSCRIBE_EMAIL_MONTHLY',  // Email subscription every 30 days
    141: 'FIRST_LOGIN_APP',          // First app download and login
    142: 'DAILY_CHECKIN',            // 7-day check-in streak
    143: 'DAILY_CHECKIN',            // 14-day check-in streak
    144: 'DAILY_CHECKIN',            // 60-day check-in streak
    145: 'DAILY_CHECKIN',            // 100-day check-in streak
    146: 'DAILY_CHECKIN',            // 200-day check-in streak
    147: 'DAILY_CHECKIN',            // 300-day check-in streak
    148: 'DAILY_CHECKIN',            // 300+ day check-in bonus
    149: 'FIRST_POST',               // First post
    150: 'POST_CREATE',              // Create post
    151: 'COMMENT_GIVEN',            // Comment on other posts
    152: 'LIKE_GIVEN',               // Like other posts
    153: 'OFFICIAL_LIKE_COMMENT',    // Official liked comment
    154: 'OFFICIAL_LIKE_POST',       // Official liked post
    155: 'OFFICIAL_RECOMMEND_POST',  // Official recommended post
    156: 'BIRTHDAY_GIFT',   // Registration anniversary care
    157: 'FIRST_ORDER',              // First order
  };

  const SHOP_ON_WEBSITE_RAYS_BP_TASK_ID = 102;

  const OPTIMIZED_RAYS_TASK_ICON_SVG_BY_CODE = {
    DAILY_CHECKIN: `
      <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="5" y="7.5" width="18" height="15.5" rx="1.5" stroke="currentColor" stroke-width="1.7"/>
        <path d="M5 12.5H23" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
        <path d="M9 5.5V9.2M19 5.5V9.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
        <path d="M10.5 17.1L13 19.4L18 14.6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
    SUBSCRIBE_EMAIL_MONTHLY: `
      <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4.8" y="6.2" width="18.4" height="14.4" rx="1.4" stroke="currentColor" stroke-width="1.7"/>
        <path d="M6.2 8.2L13.1 14.4C13.6 14.8 14.4 14.8 14.9 14.4L21.8 8.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="21.4" cy="21.2" r="5.1" fill="white"/>
        <circle cx="21.4" cy="21.2" r="4.25" stroke="currentColor" stroke-width="1.7"/>
        <text x="21.4" y="23.35" fill="currentColor" font-size="5.8" font-weight="700" text-anchor="middle" font-family="Arial, sans-serif">30</text>
      </svg>
    `,
    SUBSCRIBE_EMAIL_FIRST: `
      <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4.8" y="6.2" width="18.4" height="15.6" rx="1.4" stroke="currentColor" stroke-width="1.7"/>
        <path d="M6.2 8.2L13.1 14.4C13.6 14.8 14.4 14.8 14.9 14.4L21.8 8.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
    BIRTHDAY: `
      <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 22.5V14.8C6 12.9 7.5 11.4 9.4 11.4H18.6C20.5 11.4 22 12.9 22 14.8V22.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5 22.5H23" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
        <path d="M8 16.6L9.3 17.8C9.9 18.3 10.8 18.3 11.4 17.8C12.4 16.9 13.9 16.9 14.9 17.8C15.5 18.3 16.4 18.3 17 17.8C18 16.9 19.5 16.9 20.5 17.8L22 16.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 8V11.2M14 7V11.2M19 8V11.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
        <path d="M9 4.7V5.1M14 4V4.4M19 4.7V5.1" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
      </svg>
    `,
    
  };

  function getLangKey(acceptLanguage) {
    return String(acceptLanguage || 'en-US').split('-')[0].toLowerCase();
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function waitForUserLoginStatus(maxWait = 10000) {
    return new Promise((resolve, reject) => {
      const startedAt = Date.now();

      const check = () => {
        if (typeof UserLoginStatus !== 'undefined') {
          resolve(new UserLoginStatus());
          return;
        }

        if (Date.now() - startedAt > maxWait) {
          reject(new Error('[MembershipEarnCenter] UserLoginStatus not available'));
          return;
        }

        setTimeout(check, 50);
      };

      check();
    });
  }

  function getEarnUnit(section) {
    return section.dataset.mecEarnType === 'rays' ? 'Rays' : 'Miles';
  }

  function sanitizeTaskCode(taskCode) {
    const code = String(taskCode || '').trim();
    if (!/^[A-Za-z0-9_-]+$/.test(code)) return '';
    return code;
  }

  function getAssetBaseUrl(section) {
    if (section?.dataset?.mecAssetsBase) {
      return section.dataset.mecAssetsBase;
    }

    const script = document.querySelector('script[src*="membership-earn-center.js"]');
    if (script?.src) {
      return script.src.replace(/membership-earn-center\.js(\?.*)?$/, '');
    }

    return '';
  }

  function getTaskIconUrl(taskCode, section) {
    const code = sanitizeTaskCode(taskCode);
    if (!code || failedTaskIconCodes.has(code)) return '';

    const baseUrl = getAssetBaseUrl(section);
    if (!baseUrl) return '';

    return `${baseUrl}${encodeURIComponent(code)}.svg`;
  }

  const taskIconSvgCache = new Map();

  function getOptimizedRaysTaskIconSvgText(taskCode) {
    return OPTIMIZED_RAYS_TASK_ICON_SVG_BY_CODE[sanitizeTaskCode(taskCode)] || '';
  }

  function shouldTintSvgColor(value, el) {
    if (!value || value === 'none' || value === 'currentColor') return false;
    if (/^(#fff|#ffffff|white|rgb\(\s*255\s*,\s*255\s*,\s*255\s*\))$/i.test(value.trim())) return false;
    if (/^url\(/i.test(value)) return false;
    if (el.closest('mask')) return false;
    return true;
  }

  function tintSvgColors(svgEl) {
    const elements = [svgEl, ...svgEl.querySelectorAll('*')];

    elements.forEach((el) => {
      ['fill', 'stroke'].forEach((attr) => {
        const value = el.getAttribute(attr);
        if (!shouldTintSvgColor(value, el)) return;
        el.setAttribute(attr, 'currentColor');
      });
    });
  }

  function createTaskSvgNode(svgText, { tint = true } = {}) {
    const doc = new DOMParser().parseFromString(svgText, 'image/svg+xml');
    const svg = doc.querySelector('svg');
    if (!svg) return null;

    svg.removeAttribute('width');
    svg.removeAttribute('height');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');

    if (tint) {
      tintSvgColors(svg);
    }

    return document.importNode(svg, true);
  }

  async function fetchTaskIconSvgText(taskCode, section) {
    const code = sanitizeTaskCode(taskCode);
    if (!code || failedTaskIconCodes.has(code)) return null;

    if (taskIconSvgCache.has(code)) {
      return taskIconSvgCache.get(code);
    }

    const iconUrl = getTaskIconUrl(taskCode, section);
    if (!iconUrl) return null;

    try {
      const response = await fetch(iconUrl);
      if (!response.ok) {
        failedTaskIconCodes.add(code);
        return null;
      }

      const text = await response.text();
      taskIconSvgCache.set(code, text);
      return text;
    } catch (error) {
      failedTaskIconCodes.add(code);
      console.error('[MembershipEarnCenter] task icon fetch error:', error);
      return null;
    }
  }

  async function applyTaskIcon(iconEl, task, section, { preserveNativeColors = false } = {}) {
    if (!iconEl || !task?.taskCode) return;
    if (iconEl.dataset.mecIconState === 'loading' || iconEl.dataset.mecIconState === 'loaded') return;

    const code = sanitizeTaskCode(task.taskCode);
    if (!code) return;

    iconEl.dataset.mecIconState = 'loading';

    if (!preserveNativeColors) {
      const optimizedSvgText = getOptimizedRaysTaskIconSvgText(code);
      if (optimizedSvgText) {
        const optimizedSvg = createTaskSvgNode(optimizedSvgText, { tint: false });
        if (optimizedSvg) {
          iconEl.replaceChildren(optimizedSvg);
          iconEl.dataset.mecIconState = 'loaded';
          return;
        }
      }
    }

    const svgText = await fetchTaskIconSvgText(task.taskCode, section);
    if (!svgText || !iconEl.isConnected) {
      iconEl.dataset.mecIconState = '';
      return;
    }

    const svg = createTaskSvgNode(svgText, { tint: !preserveNativeColors });
    if (!svg) {
      failedTaskIconCodes.add(code);
      iconEl.dataset.mecIconState = '';
      return;
    }

    iconEl.replaceChildren(svg);
    iconEl.dataset.mecIconState = 'loaded';
  }

  function parseDtcSort(value) {
    if (value === null || value === undefined || value === '') return null;
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
  }

  function slugifyCategoryCode(name, index) {
    const slug = String(name || '')
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9]+/g, '_')
      .replace(/^_|_$/g, '');
    return slug || `CATEGORY_${index}`;
  }

  function getRaysTaskIconCode(bpTaskId) {
    const id = Number(bpTaskId);
    if (!Number.isFinite(id)) return '';
    return RAYS_TASK_ICON_BY_BP_TASK_ID[id] || '';
  }

  function getRaysTaskName(item, acceptLanguage) {
    const langKey = getLangKey(acceptLanguage);

    if (langKey === 'ja') {
      return item?.bpTaskDescriptionJp || item?.bpTaskDescriptionEn || item?.bpTaskDescription || '--';
    }

    if (langKey === 'en') {
      return item?.bpTaskDescriptionEn || item?.bpTaskDescription || '--';
    }

    return item?.bpTaskDescription || item?.bpTaskDescriptionEn || '--';
  }

  const SHOP_ON_WEBSITE_REWARD_BY_COUNTRY = {
    DEFAULT: {
      miles: '$1=1 Miles',
      rays: '$1 = 10 Rays',
    },
    US: {
      miles: '$1=1 Miles',
      rays: '$1 = 10 Rays',
    },
    JP: {
      miles: '100 JPY = 1 マイル',
      rays: '100 JPY = 10 ポイント',
    },
    DE: {
      miles: '1 EUR = 1 Miles',
      rays: '1 EUR = 10 Strahlen',
    },
    UK: {
      miles: '1 GBP = 1 Miles',
      rays: '1 GBP = 10 Rays',
    },
    AU: {
      miles: '1 AUD = 1 Miles',
      rays: '1 AUD = 10 Rays',
    },
    CA: {
      miles: '1 CAD = 1 Miles',
      rays: '1 CAD = 10 Rays',
    },
    EU: {
      miles: '1 EUR = 1 Miles',
      rays: '1 EUR = 10 Rays',
    },
    FR: {
      miles: '1 EUR = 1 Miles',
      rays: '1 EUR = 10 Rayons',
    },
    IT: {
      miles: '1 EUR = 1 Miglia',
      rays: '1 EUR = 10 Raggi',
    },
    ES: {
      miles: '1 EUR = 1 Millas',
      rays: '1 EUR = 10 Rayos',
    },
    PL: {
      miles: '1 EUR = 1 Mile',
      rays: '1 EUR = 10 Rayów',
    },
    NL: {
      miles: '1 EUR = 1 Miles',
      rays: '1 EUR = 10 Stralen',
    }
  };

  function getSiteCountryCode() {
    return String(window.renogyConfig?.country || '').trim().toUpperCase();
  }

  function getShopOnWebsiteRewardDisplay(type) {
    const country = getSiteCountryCode();
    const rewards = SHOP_ON_WEBSITE_REWARD_BY_COUNTRY[country] || SHOP_ON_WEBSITE_REWARD_BY_COUNTRY.DEFAULT;
    return rewards[type] || SHOP_ON_WEBSITE_REWARD_BY_COUNTRY.DEFAULT[type] || '';
  }

  function isShopOnWebsiteRaysTask(item) {
    return Number(item?.bpTaskId) === SHOP_ON_WEBSITE_RAYS_BP_TASK_ID;
  }

  function isShopOnWebsiteMilesTask(task) {
    const taskCode = sanitizeTaskCode(task?.taskCode).toUpperCase();
    const valueType = String(task?.valueType || '').trim().toUpperCase();
    return taskCode === 'SHOP_ON_WEBSITE' || valueType === 'SHOP_ON_WEBSITE';
  }

  function formatRaysRewardText(item) {
    if (isShopOnWebsiteRaysTask(item)) {
      return getShopOnWebsiteRewardDisplay('rays');
    }

    const display = item?.rewardDisplay;
    if (display !== null && display !== undefined) {
      const text = String(display).trim();
      if (text !== '' && text !== '无') {
        return text;
      }
    }

    const points = Number(item?.bpTaskBonusPoints);
    if (Number.isFinite(points) && points > 0) {
      const prefix = item?.bonusPointsType === 1 ? '-' : '+';
      return `${prefix}${points.toLocaleString('en-US', { maximumFractionDigits: 0 })} Rays`;
    }

    return '';
  }

  function isDisplayableRaysTask(item) {
    const category = String(item?.taskCategory || '').trim();
    return Boolean(category) && category.toUpperCase() !== 'NULL';
  }

  function mapRaysTaskItem(item, acceptLanguage) {
    const description = item?.description;
    const descriptionText =
      description !== null &&
      description !== undefined &&
      String(description).trim() !== '' &&
      String(description).trim() !== '无'
        ? String(description).trim()
        : '';

    return {
      bpTaskId: item?.bpTaskId,
      taskCategory: String(item?.taskCategory || '').trim(),
      taskCode: getRaysTaskIconCode(item?.bpTaskId),
      taskName: getRaysTaskName(item, acceptLanguage),
      description: descriptionText,
      rewardDisplay: formatRaysRewardText(item),
      dtcSort: item?.dtcTaskDisplayPriority,
    };
  }

  function normalizeRaysCategories(data, acceptLanguage) {
    const contentList = Array.isArray(data?.contentList) ? data.contentList : [];
    const categoryMap = new Map();
    const categoryOrder = [];

    [...contentList]
      .filter(isDisplayableRaysTask)
      .sort((a, b) => {
        const aSort = parseDtcSort(a?.dtcTaskDisplayPriority);
        const bSort = parseDtcSort(b?.dtcTaskDisplayPriority);
        if (aSort === null && bSort === null) return 0;
        if (aSort === null) return 1;
        if (bSort === null) return -1;
        return aSort - bSort;
      })
      .forEach((item) => {
        const task = mapRaysTaskItem(item, acceptLanguage);
        const categoryName = task.taskCategory;
        if (!categoryName) return;

        if (!categoryMap.has(categoryName)) {
          categoryMap.set(categoryName, {
            categoryCode: slugifyCategoryCode(categoryName, categoryOrder.length),
            categoryName,
            tasks: [],
          });
          categoryOrder.push(categoryName);
        }

        categoryMap.get(categoryName).tasks.push(task);
      });

    return categoryOrder
      .map((name) => categoryMap.get(name))
      .filter((category) => category.tasks.length > 0);
  }

  function normalizeCategories(data) {
    if (!data || !Array.isArray(data.categories)) return [];

    return data.categories
      .map((category, index) => ({
        categoryCode: String(category.categoryCode || category.categoryName || `CATEGORY_${index}`),
        categoryName: category.categoryName || category.categoryCode || `Category ${index + 1}`,
        tasks: Array.isArray(category.tasks) ? category.tasks : [],
      }))
      .filter((category) => category.tasks.length > 0);
  }

  function formatRewardText(task, earnUnit) {
    if (isShopOnWebsiteMilesTask(task)) {
      return getShopOnWebsiteRewardDisplay('miles');
    }

    const display = task.rewardDisplay;
    if (display !== null && display !== undefined && String(display).trim() !== '') {
      return String(display);
    }

    const baseValue = Number(task.baseMiles);
    if (Number.isFinite(baseValue) && baseValue > 0) {
      return `+${baseValue.toLocaleString('en-US', { maximumFractionDigits: 0 })} ${earnUnit}`;
    }

    return '';
  }

  function updateTabsScrollLayout(tabsScroll) {
    if (!tabsScroll) return;

    const isOverflowing = tabsScroll.scrollWidth > tabsScroll.clientWidth + 1;
    tabsScroll.classList.toggle('is-centered', !isOverflowing);
  }

  function observeTabsScrollLayout(tabsScroll) {
    if (!tabsScroll) return;

    const runUpdate = () => {
      updateTabsScrollLayout(tabsScroll);
      requestAnimationFrame(() => updateTabsScrollLayout(tabsScroll));
    };

    runUpdate();

    if (tabsScroll.dataset.mecScrollLayoutBound === 'true') return;
    tabsScroll.dataset.mecScrollLayoutBound = 'true';

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(runUpdate);
      observer.observe(tabsScroll);
      tabsScroll._mecTabsResizeObserver = observer;
    }

    window.addEventListener('resize', runUpdate);
  }

  function refreshTabsScrollLayout(tabsScroll) {
    if (!tabsScroll) return;

    updateTabsScrollLayout(tabsScroll);

    const observer = tabsScroll._mecTabsResizeObserver;
    if (!observer) return;

    tabsScroll.querySelectorAll('[data-mec-tab]').forEach((tab) => {
      observer.observe(tab);
    });
  }

  function bindTabs(section) {
    const tabs = section.querySelectorAll('[data-mec-tab]');
    const cards = section.querySelectorAll('[data-mec-category]');
    const emptyEl = section.querySelector('[data-mec-empty]');
    const tabsScroll = section.querySelector('[data-mec-tabs-scroll]');
    if (!tabs.length) return;

    function scrollTabToCenter(tab) {
      if (!tabsScroll || !tab) return;

      const maxScrollLeft = tabsScroll.scrollWidth - tabsScroll.clientWidth;
      if (maxScrollLeft <= 0) return;

      const targetLeft = tab.offsetLeft - (tabsScroll.clientWidth - tab.offsetWidth) / 2;
      const nextScrollLeft = Math.max(0, Math.min(targetLeft, maxScrollLeft));
      if (Math.abs(tabsScroll.scrollLeft - nextScrollLeft) < 1) return;

      tabsScroll.scrollTo({
        left: nextScrollLeft,
        behavior: 'smooth',
      });
    }

    function setActiveTab(tabId) {
      let visibleCount = 0;
      let activeTab = null;

      tabs.forEach((tab) => {
        const isActive = tab.getAttribute('data-mec-tab') === tabId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) activeTab = tab;
      });

      cards.forEach((card) => {
        const match = card.getAttribute('data-mec-category') === tabId;
        card.classList.toggle('is-hidden', !match);
        if (match) visibleCount += 1;
      });

      if (emptyEl) {
        const showEmpty = visibleCount === 0;
        emptyEl.classList.toggle('is-visible', showEmpty);
        emptyEl.hidden = !showEmpty;
      }

      scrollTabToCenter(activeTab);
    }

    tabs.forEach((tab) => {
      if (tab.dataset.mecTabBound === 'true') return;
      tab.dataset.mecTabBound = 'true';
      tab.addEventListener('click', () => {
        setActiveTab(tab.getAttribute('data-mec-tab'));
      });
    });

    const activeTab = section.querySelector('[data-mec-tab].is-active') || tabs[0];
    if (activeTab) {
      setActiveTab(activeTab.getAttribute('data-mec-tab'));
    }

    observeTabsScrollLayout(tabsScroll);
    refreshTabsScrollLayout(tabsScroll);
  }

  function buildTaskCardInnerHtml(task, options = {}) {
    const rewardText = options.rewardText ?? '';
    const limitHint = options.limitHint ?? '';
    const taskCodeAttr = task.taskCode ? ` data-mec-task-icon="${escapeHtml(task.taskCode)}"` : '';

    let rewardHtml = '';
    if (rewardText || limitHint) {
      rewardHtml = '<div class="membership-earn-center__reward">';
      if (rewardText) {
        rewardHtml += `<span class="membership-earn-center__reward-value">${escapeHtml(rewardText)}</span>`;
      }
      if (limitHint) {
        rewardHtml += `<span class="membership-earn-center__reward-hint">${escapeHtml(limitHint)}</span>`;
      }
      rewardHtml += '</div>';
    }

    return `
      <div class="membership-earn-center__card-inner">
        <div class="membership-earn-center__card-main">
          <div class="membership-earn-center__icon"${taskCodeAttr} aria-hidden="true"></div>
          <div class="membership-earn-center__content">
            <p class="membership-earn-center__card-title">${escapeHtml(task.taskName || '--')}</p>
            <p class="membership-earn-center__card-desc">${escapeHtml(task.description || '')}</p>
          </div>
        </div>
        ${rewardHtml}
      </div>
    `;
  }

  function createRaysTaskCard(task, categoryCode, section) {
    const card = document.createElement('div');
    card.className = 'membership-earn-center__card is-hidden';
    card.setAttribute('data-mec-category', categoryCode);

    if (task.bpTaskId !== null && task.bpTaskId !== undefined) {
      card.setAttribute('data-mec-bp-task-id', String(task.bpTaskId));
    }

    if (task.taskCode) {
      card.setAttribute('data-mec-task-code', task.taskCode);
    }

    card.innerHTML = buildTaskCardInnerHtml(task, {
      rewardText: task.rewardDisplay || '',
    });

    applyTaskIcon(card.querySelector('.membership-earn-center__icon'), task, section);

    return card;
  }

  function createTaskCard(task, categoryCode, earnUnit, section) {
    const card = document.createElement('div');
    card.className = 'membership-earn-center__card is-hidden';
    card.setAttribute('data-mec-category', categoryCode);
    if (task.taskCode) {
      card.setAttribute('data-mec-task-code', task.taskCode);
    }

    const rewardText = formatRewardText(task, earnUnit);
    const limitHint = task.limitHint ? String(task.limitHint).trim() : '';

    let rewardHtml = '';
    if (rewardText || limitHint) {
      rewardHtml = '<div class="membership-earn-center__reward">';
      if (rewardText) {
        rewardHtml += `<span class="membership-earn-center__reward-value">${escapeHtml(rewardText)}</span>`;
      }
      if (limitHint) {
        rewardHtml += `<span class="membership-earn-center__reward-hint">${escapeHtml(limitHint)}</span>`;
      }
      rewardHtml += '</div>';
    }

    const taskCodeAttr = task.taskCode ? ` data-mec-task-icon="${escapeHtml(task.taskCode)}"` : '';
    card.innerHTML = `
      <div class="membership-earn-center__card-inner">
        <div class="membership-earn-center__card-main">
          <div class="membership-earn-center__icon"${taskCodeAttr} aria-hidden="true"></div>
          <div class="membership-earn-center__content">
            <p class="membership-earn-center__card-title">${escapeHtml(task.taskName || '--')}</p>
            <p class="membership-earn-center__card-desc">${escapeHtml(task.description || '')}</p>
          </div>
        </div>
        ${rewardHtml}
      </div>
    `;

    applyTaskIcon(card.querySelector('.membership-earn-center__icon'), task, section, {
      preserveNativeColors: true,
    });

    return card;
  }

  function setLoadingState(section, isLoading) {
    const grid = section.querySelector('[data-mec-grid]');
    if (grid) {
      grid.classList.toggle('is-loading', isLoading);
    }
  }

  function renderApiContent(section, data, acceptLanguage) {
    const tabsScroll = section.querySelector('[data-mec-tabs-scroll]');
    const grid = section.querySelector('[data-mec-grid]');
    const emptyEl = section.querySelector('[data-mec-empty]');
    const tabsWrap = section.querySelector('[data-mec-tabs-wrap]');
    const earnType = section.dataset.mecEarnType === 'rays' ? 'rays' : 'miles';
    const categories = earnType === 'rays'
      ? normalizeRaysCategories(data, acceptLanguage)
      : normalizeCategories(data);
    const earnUnit = getEarnUnit(section);

    if (!tabsScroll || !grid) return;

    tabsScroll.innerHTML = '';
    grid.querySelectorAll('[data-mec-category]').forEach((node) => node.remove());

    if (!categories.length) {
      if (tabsWrap) tabsWrap.hidden = true;
      if (emptyEl) {
        emptyEl.classList.add('is-visible');
        emptyEl.hidden = false;
      }
      return;
    }

    if (tabsWrap) tabsWrap.hidden = false;

    categories.forEach((category, index) => {
      const { categoryCode, categoryName, tasks } = category;

      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = `membership-earn-center__tab${index === 0 ? ' is-active' : ''}`;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('data-mec-tab', categoryCode);
      tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      tab.textContent = categoryName;
      tabsScroll.appendChild(tab);

      tasks.forEach((task) => {
        const card = earnType === 'rays'
          ? createRaysTaskCard(task, categoryCode, section)
          : createTaskCard(task, categoryCode, earnUnit, section);
        grid.insertBefore(card, emptyEl || null);
      });
    });

    if (emptyEl) {
      emptyEl.classList.remove('is-visible');
      emptyEl.hidden = true;
    }

    bindTabs(section);
  }

  async function fetchApiTasks(section) {
    const earnType = section.dataset.mecEarnType === 'rays' ? 'rays' : 'miles';

    setLoadingState(section, true);

    try {
      const loginStatus = await waitForUserLoginStatus();
      const acceptLanguage = loginStatus.getAcceptLanguage();
      const data = await loginStatus.getMemberCenterEarnTasks(earnType, acceptLanguage);
      if (data) {
        renderApiContent(section, data, acceptLanguage);
      }
    } catch (error) {
      console.error('[MembershipEarnCenter] earn tasks error:', error);
    } finally {
      setLoadingState(section, false);
    }
  }

  function initSection(section) {
    if (!section || section.dataset.mecInitialized === 'true') return;
    section.dataset.mecInitialized = 'true';

    if (section.dataset.mecEnableApi === 'true') {
      fetchApiTasks(section);
      return;
    }

    bindTabs(section);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector(SECTION_SELECTOR);
    if (!section) return;
    section.dataset.mecInitialized = 'false';
    initSection(section);
  });
})();
